import AutocompleteHeader from "@/components/Search/SearchBar/AutocompleteItem/autocompleteHeader.container";
import { QuerySuggestionsItem } from "@/components/Search/SearchBar/QuerySuggestions/querySuggestions.item.component";
import { BaseTemplateProps } from "@/components/Search/SearchBar/ResultsPanel/resultsPanel.templates";
import { QuerySuggestionsSourceType } from "@/components/Search/SearchBar/searchBar.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type QuerySuggestionsTemplateProps =
    BaseTemplateProps<QuerySuggestionsSourceType>;

const QuerySuggestionsTemplate = ({
    items,
    autocompleteState,
    autocompleteActions
}: QuerySuggestionsTemplateProps) => {
    const { t } = useGranite();

    if (items.length === 0) return null;

    return (
        <div>
            <AutocompleteHeader
                headerTitle={t("searchBox.panel.querySuggestions.header.title")}
            />
            <ul className={"list-unstyled"}>
                {items.map((item) => (
                    <li key={item.objectID}>
                        <QuerySuggestionsItem
                            item={item}
                            autocompleteState={autocompleteState}
                            autocompleteActions={autocompleteActions}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default QuerySuggestionsTemplate;
